module.exports = __webpack_public_path__ + "static/007178-4771c90caf2f1b3ef900a2350c4a661f.jpg";